<template>
  <z-switch :value="local_value.active" :loading="is_loading" @input="change_status" />
</template>

<script>
  import { EditableProps } from '@shared/mixins/editable-props';

  import { CampaignsModalService } from '@autocaller_v2/modals/CampaignsModalService.js';
  export default {
    mixins: [EditableProps],
    data: () => ({ is_loading: false }),
    methods: {
      change_status(val) {
        this.is_loading = true;
        CampaignsModalService.change_status(val, this.id)
          .on('success', () => {
            this.local_value.active = val;
          })
          .on('finally', () => {
            this.is_loading = false;
          });
      }
    }
  };
</script>
